import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { PricesDto, pricesFromDto } from '@nx-frontend/shared/types';

interface GetUserPricesParams {
  host: string;
  userId: number;
}

export async function getUserPrices(params: GetUserPricesParams) {
  const { host, userId } = params;
  const response = await axiosClient.get<PricesDto>(`${assertServiceHost(host)}/v1/prices`, { userId });
  return pricesFromDto(response.data);
}
